<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="poppins fw-normal" />
    <div class="addUser">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="card">
            <div class="card-body">
              <div>
                <p class="gray-text f-18 fw-bold">Profile Picture</p>
                <section :style="{
                  'background-image': 'url(' + temp_avatar + ')',
                  'background-repeat': 'no-repeat',
                  'background-size': '100%',
                  'background-position': 'center',
                }" class="
          free_listing-banner
          d-flex
          align-items-center
          justify-content-center
          
          position-relative
        ">
                  <div class="container">
                    <div class="banner_content-wrapper">
                      <div class="banner_image__picker text-center pointer">
                        <input type="file" name="file-input" id="file-input" class="
                  file-input__input
                  position-absolute
                  overflow-hidden
                  invisible
                " @change="onFilebanner" ref="banner" />
                        <label class="
                  file-input__label
                  d-inline-flex
                  align-items-center
                  text-white
                  pointer
                  rounded
                  grey-bg
                  py-2
                  px-3
                  f-18
                  text-dark
                " for="file-input">
                          <template v-if="!form.avatar">
                            <img src="@/assets/images/AddUser.svg" alt="Add Customer">
                            <span class="f-16 fw-400  mb-0">Upload <br> Profile Picture</span>
                          </template>
                        </label>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div>
                <p class="text-start f-18 fw-bold gray-text py-3 mb-0"> Customer Info</p>
              </div>
              <form ref="form" @submit.prevent="submit" novalidate>
                <div class="row">
                  <!-- Customer Information Start From Here -->
                  <div class="col-sm-6 col-md-4">
                    <div class="form-group mt-4 mt-md-0 mb-0 mb-mb-3">
                      <BreezeInput id="floatingInputName" type="text"
                        class="form-control input-padding fs-14 rounded-pill" placeholder=""
                        aria-describedby="nameHelpInline" required v-model="form.first_name" maxlength="100" />
                      <div v-if="$v.form.first_name.$error">
                        <div class="error" v-if="!$v.form.first_name.required">
                          First Name is Required!
                        </div>
                        <div class="error" v-if="$v.form.first_name.maxLength === false">
                          First Name cannot exceed 100 characters!
                        </div>
                      </div>
                      <BreezeLabel for="floatingInputName" class="gray-text fs-14 px-2" value="Enter Your First Name" />
                      <div v-if="$v.form.first_name.$error">
                        <div class="error" v-if="!$v.form.first_name.required">
                          First Name is Required!
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-4">
                    <div class="form-group mt-4 mt-md-0 mb-0 mb-3">
                      <BreezeInput id="floatingInputLastName" type="text"
                        class="form-control input-padding fs-14 rounded-pill" placeholder=""
                        aria-describedby="nameHelpInline" required v-model="form.last_name" maxlength="100" />
                      <div v-if="$v.form.last_name.$error">
                        <div class="error" v-if="!$v.form.last_name.required">
                          Last Name is Required!
                        </div>
                        <div class="error" v-if="$v.form.last_name.maxLength === false">
                          Last Name cannot exceed 100 characters!
                        </div>
                      </div>
                      <BreezeLabel for="floatingInputLastName" class="gray-text fs-14 px-2"
                        value="Enter Your Last Name" />
                      <div v-if="$v.form.last_name.$error">
                        <div class="error" v-if="!$v.form.last_name.required">
                          Last Name is Required!
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput id="formrow-email-input" type="email"
                        class="form-control fs-14 rounded-pill px-4 input-padding" required v-model="form.email"
                        placeholder="" autocomplete="email" />
                      <BreezeLabel for="formrow-email-input" class="gray-text fs-14 px-2" value="Email" />
                      <div class="error" v-if="$v.form.email.$error">
                        <div class="error" v-if="!$v.form.email.required">
                          Email is Required!
                        </div>
                        <div class="error" v-if="!$v.form.email.email">
                          Please Enter Valid Email
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput id="formrow-mobile-input" type="number"
                        class="form-control fs-14 rounded-pill px-4 input-padding" required v-model="form.mobile"
                        placeholder="" autocomplete="tel" />
                      <BreezeLabel for="formrow-mobile-input" class="gray-text fs-14 px-2" value="Phone" />
                      <div class="error" v-if="$v.form.mobile.$error">
                        <div class="error" v-if="!$v.form.mobile.required">
                          Mobile Number is Required!
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                        v-model="address.address" id="address-field-address" placeholder="" autocomplete="address-line1" />
                      <BreezeLabel class="gray-text fs-14 px-2" for="address-field-address">
                        Address
                      </BreezeLabel>
                      <div class="error" v-if="$v.address.address.$error">
                        <div class="error" v-if="!$v.address.address.required">
                          Address is Required!
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput id="address-field-city" type="text"
                        class="form-control fs-14 rounded-pill px-4 input-padding" required v-model="address.city"
                        placeholder="" autocomplete="address-line2" />
                      <BreezeLabel for="address-field-city" class="gray-text fs-14 px-2" value="City/Town" />
                      <div class="error" v-if="$v.address.city.$error">
                        <div class="error" v-if="!$v.address.city.required">
                          City/Town is Required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <select class="form-select border-radius-24 fs-14 mb-3 gray-text" aria-label="Country" required
                        v-model="address.country">
                        <option value="" disabled>Country*</option>
                        <option v-for="(name, code) in countries" :key="code" :value="code">
                          {{ name }}
                        </option>
                      </select>
                      <div class="error" v-if="$v.address.country.$error">
                        <div class="error" v-if="!$v.address.country.required">
                          Country is Required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput id="state-id" type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                        required v-model="address.state" placeholder="" autocomplete="address-level1" />
                      <BreezeLabel for="state-id" class="gray-text fs-14 px-2" value=" State/Province" />
                      <div class="error" v-if="$v.address.state.$error">
                        <div class="error" v-if="!$v.address.state.required">
                          State/Province is Required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput id="zip_id" type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                        required v-model="address.zipcode" placeholder="" autocomplete="postal-code" />
                      <BreezeLabel for="zip_id" class="gray-text fs-14 px-2" value=" Zip Code" />
                      <div class="error" v-if="$v.address.zipcode.$error">
                        <div class="error" v-if="!$v.address.zipcode.required">
                          Zip Code is Required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput type="password"
                        :class="['form-control input-padding fs-14 rounded-pill', isPasswordRequired && !isPasswordStrong ? 'border-danger' : isPasswordStrong ? 'border-success' : '']"
                        v-model="form.password" id="formrow-Password" placeholder="" autocomplete="new-password" />
                      <BreezeLabel class="form-label gray-text fs-14 px-2" for="formrow-Password">
                        Password
                      </BreezeLabel>
                      <div class="error" v-if="$v.form.password.$error">
                        <p class="text-danger" v-if="!$v.form.password.required">Password is required</p>
                        <p v-if="!isPasswordStrong && form.password?.length > 0" class="text-danger">
                          Password must be at least 8 characters long, include one uppercase letter, one lowercase
                          letter, one number,
                          and one special character.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput type="password" class="form-control fs-14 rounded-pill px-4 input-padding"
                        v-model="form.confirmPassword" id="c-password" placeholder="" autocomplete="new-password" />
                      <BreezeLabel class="form-label gray-text fs-14 px-2" for="c-password">
                        Confirm Password
                      </BreezeLabel>
                      <div class="error" v-if="$v.form.confirmPassword.$error">
                        <div class="error" v-if="!$v.form.confirmPassword.required">
                          Confirm Password is Required!
                        </div>
                        <div class="error " v-if="!$v.form.confirmPassword.sameAsPassword">
                          Password and Confirm Password Should Match
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Customer Information End Here -->

                  <!-- User Membership Start Here -->
                  <template v-if="!couponChecked">
                    <div class="col-md-12 mt-0">
                      <div class="mb-3 d-flex align-items-center">
                        <input type="checkbox" class="" v-model="form.send_as_gift" :true-value="true" :false-value="false"
                          @change="toggleCheckbox('send_as_gift')" id="sendAsGift" placeholder="" />
                        <label class="ms-2 mb-0" for="sendAsGift">
                          Send as Gift
                        </label>
                      </div>
                    </div>
                    <template v-if="form.send_as_gift && !couponChecked">
                      <!-- Receiver First Name -->
                      <div class="col-sm-6 col-md-4">
                        <div class="form-group mb-3">
                          <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                            v-model="form.reciever_info.first_name" placeholder="" name="receiver-first-name" />
                          <BreezeLabel class="gray-text fs-14 px-2" for="receiver-first-name"
                            value="Recipient First Name *" />
                          <p v-if="$v.form.reciever_info.first_name.$error" class="text-danger">
                            First name is required
                          </p>
                        </div>
                      </div>

                      <div class="col-sm-6 col-md-4">
                        <div class="form-group mb-3">
                          <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                            v-model="form.reciever_info.last_name" placeholder="" name="receiver-last-name" />
                          <BreezeLabel class="gray-text fs-14 px-2" value="Recipient Last Name *" />
                          <p v-if="$v.form.reciever_info.last_name.$error" class="text-danger">
                            Last name is required
                          </p>
                        </div>
                      </div>

                      <!-- Receiver Email -->
                      <div class="col-sm-6 col-md-4">
                        <div class="form-group mb-3">
                          <BreezeInput type="email" class="form-control fs-14 rounded-pill px-4 input-padding"
                            v-model="form.reciever_info.email" placeholder="" name="receiver-email" />
                          <BreezeLabel class="gray-text fs-14 px-2" value="Recipient Email *" />
                          <p v-if="$v.form.reciever_info.email.$error" class="text-danger">
                            Email is required
                          </p>
                          <!-- <p v-if="unique_email" class="text-danger">
                            Email should not be the same
                          </p> -->
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="mb-3 d-flex align-items-center">
                          <input type="checkbox" v-model="form.recipient_address" id="recipientAddress" class="me-2" />
                          <label for="recipientAddress" class="mb-0">
                            Ship directly to recipient
                          </label>
                        </div>
                      </div>

                      <!-- Recipient Address Fields -->
                      <template v-if="form.recipient_address">
                        <!-- <div class="row mt-4"> -->

                          <!-- Address -->
                          <div class="col-sm-6 col-md-4">
                            <div class="form-group mb-3">
                              <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                                v-model="form.reciever_info.address.address" placeholder="" name="receiver-address" />
                              <BreezeLabel class="gray-text fs-14 px-2" value="Address *" />
                              <p v-if="$v.form.reciever_info.address.address.$error" class="text-danger">
                                Address is required
                              </p>
                            </div>
                          </div>

                          <!-- City -->
                          <div class="col-sm-6 col-md-4">
                            <div class="form-group mb-3">
                              <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                                v-model="form.reciever_info.address.city" placeholder="" name="receiver-city" />
                              <BreezeLabel class="gray-text fs-14 px-2" value="City *" />
                              <p v-if="$v.form.reciever_info.address.city.$error" class="text-danger">
                                City is required
                              </p>
                            </div>
                          </div>

                          <!-- Country -->
                          <div class="col-sm-6 col-md-4">
                            <div class="form-group mb-3">
                              <select class="form-select border-radius-24 fs-14 gray-text"
                                v-model="form.reciever_info.address.country">
                                <option value="" disabled>Country *</option>
                                <option v-for="(name, code) in countries" :key="code" :value="code">
                                  {{ name }}
                                </option>
                              </select>
                              <p v-if="$v.form.reciever_info.address.country.$error" class="text-danger">
                                Country is required
                              </p>
                            </div>
                          </div>

                          <!-- State -->
                          <div class="col-sm-6 col-md-4">
                            <div class="form-group mb-3">
                              <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                                v-model="form.reciever_info.address.state" placeholder="" name="receiver-state" />
                              <BreezeLabel class="gray-text fs-14 px-2" value="State *" />
                              <p v-if="$v.form.reciever_info.address.state.$error" class="text-danger">
                                State is required
                              </p>
                            </div>
                          </div>

                          <!-- Zip Code -->
                          <div class="col-sm-6 col-md-4">
                            <div class="form-group mb-3">
                              <BreezeInput type="text" class="form-control fs-14 rounded-pill px-4 input-padding"
                                v-model="form.reciever_info.address.zipcode" placeholder="" name="receiver-zipcode" />
                              <BreezeLabel class="gray-text fs-14 px-2" value="Zip Code *" />
                              <p v-if="$v.form.reciever_info.address.zipcode.$error" class="text-danger">
                                Zip code is required
                              </p>
                            </div>
                          </div>
                        <!-- </div> -->

                      </template>
                    </template>
                    <!-- Membership Free Options -->
                  </template>

                  <div class="row mt-4" v-if="false">

                    <div class="col-sm-6 col-md-4">
                      <div class="mb-3 d-flex align-items-center">
                        <input type="checkbox" v-model="form.one_month_free" true-value="1" false-value="0"
                          @change="toggleCheckbox('one_month_free')" id="oneMonth" />
                        <label class="ms-2 mb-0" for="oneMonth">
                          One Month Free
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                      <div class="mb-3 d-flex align-items-center">
                        <input type="checkbox" v-model="form.one_year_free" true-value="1" false-value="0"
                          @change="toggleCheckbox('one_year_free')" id="oneYear" />
                        <label class="ms-2 mb-0" for="oneYear">
                          One Year Free
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                      <div class="mb-3 d-flex align-items-center">
                        <input type="checkbox" v-model="form.life_time_free" true-value="1" false-value="0"
                          @change="toggleCheckbox('life_time_free')" id="lifeTime" />
                        <label class="ms-2 mb-0" for="lifeTime">
                          Life Time Free
                        </label>
                      </div>
                    </div>

                  </div>

                  <template>
                    <div class="row mt-0">
                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3 d-flex align-items-center">
                          <input type="radio" id="month" @change="manageBillingType('month')" value="month" v-model="form.interval" class="me-2" />
                          <label for="month" class="mb-0">
                            {{ form.interval == "month" ? finalPrice.toFixed(2) : "$9.00" }} Billed Monthly (9$/month)
                          </label>
                        </div>
                      </div>

                      <div class="col-sm-6 col-md-4">
                        <div class="mb-3 d-flex align-items-center">
                          <input type="radio" id="year" @change="manageBillingType('year')" value="year" v-model="form.interval" class="me-2" />
                          <label for="year" class="mb-0">
                            {{ form.interval == "year" ? finalPrice.toFixed(2) : "$99.00" }} Billed Yearly (99$/year)
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="mt-0">
                      <p class="fs-18">Add Discount Coupan</p>
                      <div class="row align-items-center gap-3 gap-sm-0">
                        <div class="col-sm-6 col-md-4">
                          <div class="form-group d-flex align-items-start gap-2 mb-0">
                            <div class="flex-grow-1">
                              <BreezeInput id="couponCode" v-bind:readonly="couponChecked" type="text" v-model="form.coupon"
                                class="form-control fs-14 rounded-pill px-4 input-padding" placeholder="" />
                              <BreezeLabel for="couponCode" class="form-label gray-text fs-14 px-2">Coupon Code
                              </BreezeLabel>
                              <div v-if="!couponError">
                                <p class="text-danger mb-0">{{ couponMessage }}</p>
                              </div>
  
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 col-md-2">
                          <div class=" border-orange p1 rounded-pill">
                              <button @click="coupnCheck()" type="button"
                                class="btn rounded-pill bg-orange white-color text-white fw-bold w-100 h-44"
                                :disabled="couponChecked || coupanLoading">
                                <template v-if="coupanLoading">
                                  <i class="fa fa-spinner fa-spin"></i> Apply
                                </template>
                                <template v-else>
                                  {{ couponChecked ? '$'+couponAmount.toFixed(2)+' Discount Applied' : 'Apply' }}
                                </template>
                              </button>
                            </div>
                        </div>
                      </div>
                      <div class="col-md-5 d-flex align-items-center">
                        <div class="" v-if="couponChecked && coupanObject">
                            <p v-if="coupanObject?.percent_off"><b>Percent Off:</b> {{ coupanObject?.percent_off }}% <b>Duration:</b> {{ coupanObject?.duration }}</p>
                            <p v-if="coupanObject?.amount_off"><b>Amount Off:</b> ${{ coupanObject?.amount_off / 100 }} <b>Duration:</b> {{ coupanObject?.duration }}</p>
                          </div>
                      </div>
                    </div>

                    <div class="row mt-4" v-if="paymentRequired">
                      <div class="col-md-6">
                        <div class="d-flex gap-lg-5 justify-content-between flex-column flex-md-row">
                          <p class="fs-18 mb-0">Add Customer Payment Details</p>
                          <div class="d-flex gap-2 align-items-start flex-wrap">
                            <img src="@/assets/images/visa.png" alt="main-logo" class="img-fluid object-fit-contain"
                              height="20px" width="30px" />
                            <img src="@/assets/images/mastercard.png" alt="main-logo"
                              class="img-fluid object-fit-contain" height="20px" width="30px" />
                            <img src="@/assets/images/card3.png" alt="main-logo" class="img-fluid object-fit-contain"
                              height="20px" width="30px" />
                            <img src="@/assets/images/cards4.png" alt="main-logo" class="img-fluid object-fit-contain"
                              height="20px" width="30px" />
                            <img src="@/assets/images/cards5.png" alt="main-logo" class="img-fluid object-fit-contain"
                              height="20px" width="30px" />
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="">
                            <StripePayment ref="stripePM" title="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="d-flex justify-content-end gap-3">
                  <div class="cta_submit button text-end border-orange fit-content rounded-pill p1 float-end custom-width">
                    <SubmitButton :processing="processing" type="submit"
                      class="btn btn-primary waves-effect waves-light h-44" text="Add Customer" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>
<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import { required, requiredIf, email, sameAs, minLength } from "vuelidate/lib/validators";
import BreezeInput from "@/components/Input/input";
import BreezeLabel from "@/components/Input/label";
import StripePayment from "@/components/StripePaymentMethod";

export default {

  page: {
    title: "Add Customer",
    meta: [
      {
        name: "add-user",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BreezeInput,
    BreezeLabel,
    StripePayment,
  },
  data() {
    return {
      countries: [],
      processing: false,
      temp_avatar: null,
      isFree: false,
      isAdmin: false,
      coupanObject: null,
      errors: [],
      form: {
        avatar: null,
        first_name: null,
        email: null,
        mobile: null,
        password: null,
        confirmPassword: null,
        one_month_free: 0,
        one_year_free: 0,
        life_time_free: 0,
        coupon: null,
        payment_method_id: null,
        send_as_gift: false,
        recipient_address: false,
        reciever_info: {
          first_name: null,
          last_name: null,
          email: null,
          address: {
            address: null,
            city: null,
            country: "US",
            state: null,
            zipcode: null,
          }
        },
        interval: "month",
      },
      couponChecked: false,
      coupanLoading: false,
      address: {
        address: "",
        city: "",
        country: "",
        state: "",
        zipcode: "",
      },
      title: "Add Customer",
      items: [
        {
          text: "Omaha",
        },
        {
          text: "Add Customer",
          active: true,
        },
      ],
      couponError: false,
      couponMessage: "",
      paymentRequired: true,
      couponAmount: 0,
      pricing: {
        month: {
          price: 9.00,
          interval: 'month'
        },
        year: {
          price: 99.00,
          interval: 'year'
        }
      },
    };
  },
  validations: {
    form: {
      first_name: {
        required,
        maxLength: value => !value || value.length <= 100,
        // alpha,
      },
      last_name: {
        required,
        maxLength: value => !value || value.length <= 100,
      },
      email: {
        email,
        required,
      },
      mobile: {
        required,
      },
      password: {
        required,
        minLength: minLength(8)
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password')
      },
      reciever_info: {
        first_name: {
          required: requiredIf(function () {
            return this.form.send_as_gift;
          })
        },
        last_name: {
          required: requiredIf(function () {
            return this.form.send_as_gift;
          })
        },
        email: {
          required: requiredIf(function () {
            return this.form.send_as_gift;
          }),
          email
        },
        address: {
          address: {
            required: requiredIf(function () {
              return this.form.recipient_address === true;
            })
          },
          city: {
            required: requiredIf(function () {
              return this.form.recipient_address === true;
            })
          },
          country: {
            required: requiredIf(function () {
              return this.form.recipient_address === true;
            })
          },
          state: {
            required: requiredIf(function () {
              return this.form.recipient_address === true;
            })
          },
          zipcode: {
            required: requiredIf(function () {
              return this.form.recipient_address === true;
            })
          }

        }
      },
    },
    address: {
      address: {
        required
      },
      city: {
        required,
      },
      country: {
        required,
      },
      state: {
        required,
      },
      zipcode: {
        required,
      }

    }
  },
  computed: {
    isPasswordStrong() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      return regex.test(this.form.password);
    },
    isPasswordRequired() {
      return !!this.form.password;
    },

    basePrice() {
      return this.pricing[this.form.interval].price;
    },

    finalPrice() {
      if (this.couponChecked) {
        return Math.max(this.basePrice - this.couponAmount, 0);
      }
      return this.basePrice;
    },


  },
  mounted() {
    if (this.$route.query.free === "true") {
      this.isFree = true;
    }
    if (this.$route.query.admin === "true") {
      this.isAdmin = true;
      this.title = "Add Admin User";
      this.items[this.items.length - 1].text = "Add Admin User";
    }
    this.getCountries();
  },
  methods: {
    async manageBillingType(type){
        this.form.interval = type;
        if(this.form.coupon && this.couponChecked){
            await this.getCoupanAmountOff();
        }
        if(this.finalPrice == 0){
            this.paymentRequired = false;
        }else {
            this.paymentRequired = true;
        }
    },
    resetSendAsGift(){
      this.form.send_as_gift = false;
      this.form.recipient_address = false;
      this.form.reciever_info = {
          first_name: null,
          last_name: null,
          email: null,
          address: {
            address: null,
            city: null,
            country: "US",
            state: null,
            zipcode: null,
          }
        };
    },
    async coupnCheck() {
      if (!this.form.coupon) {
        return true;
      }
      this.coupanLoading = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      await this.checkCoupn(this.form.coupon)
        .then((data) => {
          this.couponError = data.status;
          this.couponMessage = data.message;
          if (!this.couponError) {
            this.form.processing = false;
            this.coupanLoading = false;
          }
          if (data.status) {
            this.coupanObject = data.coupon;
            this.getCoupanAmountOff();
            this.couponChecked = true;
            this.triggerSwal('Coupon applied', "success");
            this.paymentRequired = this.finalPrice > 0;
            this.coupanLoading = false;
            this.resetSendAsGift()
          } else {
            this.paymentRequired = true;
            this.coupanLoading = false;
            this.couponAmount = 0;
            this.paymentRequired = true;
          }
          return true;
        });


      if (!this.couponError) {
        this.form.processing = false;
        this.coupanLoading = false;
        return false;
      }

    },
    getCoupanAmountOff() {
      this.couponAmount = 0;

      let coupon = this.coupanObject;

      if (!coupon) {
        return;
      }

      const price = this.pricing[this.form.interval].price;

      if (coupon.amount_off) {
        this.couponAmount = coupon.amount_off / 100;
      }

      if (coupon.percent_off) {
        this.couponAmount = (price * coupon.percent_off) / 100;
      }

      return this.couponAmount;
    },
    toggleCheckbox(selected) {
      console.log("selected", selected)
      if (selected === "one_year_free") {
        this.form.life_time_free = 0;
        this.form.one_month_free = 0;
      } else if (selected === "life_time_free") {
        this.form.one_year_free = 0;
        this.form.one_month_free = 0;
      } else if (selected === "one_month_free") {
        this.form.one_year_free = 0;
        this.form.life_time_free = 0;
      }
    },
    onFilebanner(e) {
      const file = e.target.files[0];
      this.form.avatar = this.$refs.banner.files[0];
      this.temp_avatar = URL.createObjectURL(file);
    },
    selectMedia(e) {
      const file = e.target.files[0];
      console.log(file);
    },
    getCountries() {
      this.$axios
        .get("countries")
        .then((response) => {
          this.countries = response?.data?.data;

        })
        .catch((error) => {
          console.error('Error fetching countries:', error);
        });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.isPasswordStrong) {
        this.submitStatus = "ERROR";
      } else {
        let self = this;
        self.processing = true;

        if (this.paymentRequired) {

          try{
            var payment_method_id = await this.$refs.stripePM.getPaymentMethodId();
            this.form.payment_method_id = payment_method_id;
            if (!payment_method_id) {
              this.triggerSwal("Payment method not found", "error");
              this.processing = false;
              return;
            }
          }catch(e){
            this.triggerSwal(e.message, "error");
            this.processing = false;
            return;
          }
          
        } else {
          this.form.payment_method_id = null;
        }

        const formData = new FormData();
        if (this.form.avatar) {
          formData.append("avatar", this.form.avatar);
        }
       
        formData.append("first_name", this.form.first_name);
        formData.append("last_name", this.form.last_name);
        formData.append("email", this.form.email);
        formData.append("mobile", this.form.mobile);
        formData.append("password", this.form.password);
        formData.append("password_confirmation", this.form.confirmPassword);
        formData.append('address', JSON.stringify(this.address));
        formData.append('send_as_gift', this.form.send_as_gift);
        formData.append('recipient_address', this.form.recipient_address);
        formData.append('reciever_info', JSON.stringify(this.form.reciever_info));
        formData.append('interval', this.form.interval);
        if(this.couponChecked){
          formData.append('coupon', this.form.coupon);
        }
        if(this.form.payment_method_id){
          formData.append('payment_method_id', this.form.payment_method_id);
        }
     
        this.$axios
          .post("create-premium-user", formData)
          .then((response) => {

            if(!response.data.status){
              this.triggerSwal(response.data.message, "error");
              this.processing = false;
              return;
            }

            if(this.$route.query.redirect_back_to){
              this.$router.push({ path: this.$route.query.redirect_back_to });
            }

            if (this.isAdmin) {
              this.$router.push({ path: "/AdminUsers/Listing" });
            } else if (this.isFree) {
              this.$router.push({ path: "/FreeUsers/Listing" });
              this.isFree = false;
            } else {
              this.$router.push({ path: "/users/listing" });
            }
            this.triggerSwal(response.data.message, "success");
            this.$refs.form.reset();
            this.processing = false;
          })
          .catch((error) => {
            this.processing = false;
            const errors = error.response?.data?.errors;

            if (errors && typeof errors === 'object') {
              const firstError = Object.values(errors)?.[0]?.[0];

              if (firstError) {
                this.triggerSwal(firstError, 'error');
                return;
              }
            }
            this.handleErrorResponse(error.response, "error");
          });
      }
    },
  },

};
</script>
<style scoped>
/***Form Fields****/
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.h-44{
  height : 44px;
}
.custom-width{
  width : 100%;
}
@media (min-width : 576px){
  .custom-width{
    width : auto !important;
  }
}
</style>